// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"9eef63d9","333":"0b3ed199","416":"2355b7cd","473":"7e28d66b","549":"673ae6f8","552":"d8466a89","731":"5642e8a8","754":"a852b3db"}[chunkId] + ".chunk.js";
};